var map = {
  "./cs.json": [
    "adH",
    [
      0
    ]
  ],
  "./en.json": [
    "fu",
    [
      "x"
    ]
  ],
  "./pl.json": [
    "cLb",
    [
      "6m"
    ]
  ],
  "./ru.json": [
    "znN",
    [
      "dai"
    ]
  ],
  "./tr.json": [
    "PE",
    [
      967
    ]
  ],
  "./ja.json": [
    "Gf",
    [
      "gn"
    ]
  ],
  "./zh.json": [
    "r4",
    [
      "pa"
    ]
  ],
  "./pt-br.json": [
    "S1",
    [
      "kd"
    ]
  ],
  "./de.json": [
    "D0j",
    [
      "pz"
    ]
  ],
  "./es.json": [
    "Ff",
    [
      "v5o"
    ]
  ],
  "./fr.json": [
    "pT2",
    [
      "n3"
    ]
  ],
  "./it.json": [
    "XC",
    [
      "53n"
    ]
  ],
  "./ko.json": [
    "Y9G",
    [
      "uig"
    ]
  ],
  "./pt.json": [
    "wzp",
    [
      "2wn"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "eD";
module.exports = __rspack_async_context;
